import useMuiMediaQuery from "@mui/material/useMediaQuery"

export function useMediaQuery(query) {

    return useMuiMediaQuery(query, { noSsr: true })
}